// AggregatorStatusChip — status pill for TBO / Mystifly driven by SSE events.


export type AggregatorStatus = 'pending' | 'searching' | 'complete' | 'failed';

export interface AggregatorState {
  aggregator: string;
  status: AggregatorStatus;
  errorCode?: string;
}

interface Props {
  state: AggregatorState;
}

const STATUS_LABEL: Record<AggregatorStatus, string> = {
  pending:   '● Connecting',
  searching: '⟳ Searching',
  complete:  '✓ Done',
  failed:    '✕ Unavailable',
};

const STATUS_COLOR: Record<AggregatorStatus, string> = {
  pending:   'rgba(255,255,255,0.08)',
  searching: 'rgba(75,142,219,0.15)',
  complete:  'rgba(22,163,74,0.15)',
  failed:    'rgba(232,68,26,0.12)',
};

const STATUS_TEXT_COLOR: Record<AggregatorStatus, string> = {
  pending:   '#8C98B0',
  searching: '#4B8EDB',
  complete:  '#4ade80',
  failed:    '#E8441A',
};

export function AggregatorStatusChip({ state }: Props) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 12px',
        borderRadius: 999,
        background: STATUS_COLOR[state.status],
        border: `1px solid ${STATUS_TEXT_COLOR[state.status]}22`,
      }}
    >
      <span style={{
        fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif',
        fontSize: 11,
        fontWeight: 700,
        color: '#8C98B0',
        letterSpacing: 1,
        textTransform: 'uppercase',
      }}>{state.aggregator}</span>
      <span style={{
        fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif',
        fontSize: 12,
        fontWeight: 500,
        color: STATUS_TEXT_COLOR[state.status],
      }}>{STATUS_LABEL[state.status]}</span>
      {state.status === 'failed' && state.errorCode && (
        <span style={{
          fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif',
          fontSize: 10,
          color: '#8C98B0',
        }}>· {state.errorCode}</span>
      )}
    </div>
  );
}
